import { ELEMENT_TYPE_KEYS } from '../constants/planning.constants';
import { toDateKey } from '../utils/planningDates';

export const createPlanningDraft = (type = 'task', date = new Date()) => {
  const elementType = ELEMENT_TYPE_KEYS.includes(type) ? type : 'event';
  const dateKey = toDateKey(date);
  return {
    id: null,
    title: '',
    description: '',
    elementType,
    status: 'planned',
    startDate: dateKey,
    startTime: '09:00',
    endDate: dateKey,
    endTime: '10:00',
    durationMinutes: 60,
    isAllDay: elementType === 'milestone',
    projectId: null,
    taskId: null,
    deliverableId: null,
    clientId: null,
    resourceId: null,
    owner: '',
    location: '',
    priority: 'normal',
    progress: 0,
    estimatedHours: 0,
    completedHours: 0,
    remainingHours: 0,
    isLocked: false,
    isBillable: false,
    externalCalendarId: null,
    externalEventId: null,
    syncStatus: 'not_synced',
    lastSyncedAt: null,
    syncError: null,
  };
};
